export default class ProductAjax {
    constructor() {
        this.LANGUAGE = '/' + document.documentElement.lang;
        //Cart
        this.addToCartURL = this.LANGUAGE + '/add/to/cart';
        this.addToCartIdsURL = this.LANGUAGE + '/add/to/cart/ids';
        this.getCartURL = this.LANGUAGE + '/get/cart/product';
        this.deleteCartURL = this.LANGUAGE + '/delete/cart/product';
        this.setCartURL = this.LANGUAGE + '/set/cart/count/product';
        //Favorites
        this.addToFavoriteUrl = this.LANGUAGE + '/add/to/favorites';
        this.delFromFavoriteUrl = this.LANGUAGE + '/remove/from/favorites';
        this.delFavoriteListUrl = this.LANGUAGE + '/profile/favorites/delete/list';
        this.getSmallFavUrl = this.LANGUAGE + '/profile/favorites/small/list';
        //Compare
        this.addToCompareUrl = this.LANGUAGE + '/compare/save';
        this.getCompareUrl = this.LANGUAGE + '/compare/list';
        this.deleteItemURL = this.LANGUAGE + '/compare/delete-item';
        this.deleteCatURL = this.LANGUAGE + '/compare/delete-category';
        //Awayt
        this.addToAwayUrl = this.LANGUAGE + '/profile/awayt/add';
        this.deleteToAwayUrl = this.LANGUAGE + '/profile/awayt/delete';
    }

    /**
     *
     * @param url
     * @param callback
     * @private
     */
    _GET(url, callback) {
        $.ajax({
            type: "GET",
            url: url,
            processData: false,
            contentType: false,
            dataType: "json"
        }).done(function (res) {
            callback(res);
        });
    }

    /**
     *
     * @param url
     * @param data
     * @param callback
     * @private
     */
    _POST(url, data, callback) {
        let formData = new FormData();

        if(data) {
            for (let property in data) {
                formData.append(property, data[property]);
            }
        }

        $.ajax({
            type: "POST",
            url: url,
            processData: false,
            contentType: false,
            data: formData,
            dataType: "json"
        }).done(function (res) {
            callback(res);
        });
    }

    /**
     *
     * @param confName
     * @param allClose
     */
    confirmDelete(confName, allClose) {
        $('#confirm_delete button[type=button]').on('click', function (){
            $(document).trigger(confName);
            if(allClose === true) {
                $('#confirm_delete .close-popup').trigger('click');
            } else {
                $('#confirm_delete').fadeOut(200);
            }
        });
    }
}
